import { gql } from '@apollo/client';

import { CONVERSATION_FIELDS_FRAGMENT } from '../conversations/conversationFieldsFragment.gql';

export const EXPERT_QUEUE_FIELDS_FRAGMENT = gql`
  ${CONVERSATION_FIELDS_FRAGMENT}
  fragment ExpertQueueFields on ExpertQueue {
    isActive
    nominationExpiresAt
    conversationPtr {
      ...ConversationFields
    }
  }
`;
